import React from 'react'

const FloatLabelInput = ({ className, style, value, handleInputChange, readOnlyField, spanName, verifiedCheckMark, toolTipContent }) => {
   return (<>
        <label className="has-float-label">
            <input
                className={`form-control ${className}`}
                style={style}
                type="text"
                placeholder=''
                value={value}
                onChange={handleInputChange}
                readOnly={readOnlyField}
            />
            <span>{spanName}</span>
            {
                verifiedCheckMark &&
                <svg className='react-tooltip'
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={verifiedCheckMark}
                    data-tooltip-place="top"
                >
                    <path
                        d="M8.99739 17.3346C4.39502 17.3346 0.664062 13.6036 0.664062 9.0013C0.664062 4.39893 4.39502 0.667969 8.99739 0.667969C13.5997 0.667969 17.3307 4.39893 17.3307 9.0013C17.3307 13.6036 13.5997 17.3346 8.99739 17.3346ZM8.16623 12.3346L14.0588 6.44208L12.8803 5.26357L8.16623 9.97763L5.80924 7.62055L4.63072 8.79913L8.16623 12.3346Z"
                        fill="#008000"
                    />
                </svg>
            }
        </label>
    </>);
}

export default FloatLabelInput